import { createReducer } from '@reduxjs/toolkit';

import getAcceptanceIssues from '../../../thunks/coilovers/acceptance/getAcceptanceIssues';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getAcceptanceIssuesReducer = createReducer(initialState, {
  [getAcceptanceIssues.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getAcceptanceIssues.fulfilled]: (state, {
    payload: {
      data, current_page: currentPage, last_page: lastPage, total
    }
  }) => ({
    ...state,
    loading: false,
    data,
    currentPage,
    lastPage,
    total
  }),
  [getAcceptanceIssues.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getAcceptanceIssuesReducer;
